import React from 'react'
import Progress from '../components/Progress.js';
import RentalList from '../components/RentalList.js';
import RezCentral from '../components/RezCentral.js';
import SCR from '../components/SCR.js';
import {Container, Row, Col, Stack, Accordion, Spinner} from 'react-bootstrap';

export default class Step2 extends React.Component {
  //rental_list = [];
  list_copy = [];

  constructor(props){
      super(props);

      this.state = {
        loading : false,

        rentalList : [],
        filtersSelected : [],
        sortSelected : '',
        errorMessage : ''
      }

      this.handleFilterSelect = this.handleFilterSelect.bind(this);
      this.handleSort = this.handleSort.bind(this);
      this.sort = this.sort.bind(this);
      //this.setUpgradeList = this.setUpgradeList.bind(this);
  }

  componentDidUpdate(){
    //console.log('UPDATING ')
     SCR.resizeParent();
  }

  componentDidMount() {
    var self = this;

    var rateData = {
      pickupLocationId : this.props.pickup.locationId,
      dropoffLocationid : this.props.dropoff.locationId,
      pickupDateTime : this.getDateString(this.props.pickup.date) + ' ' + this.props.pickup.time,
      dropoffDateTime : this.getDateString(this.props.dropoff.date) + ' ' + this.props.dropoff.time,
      discountCode : this.props.discountCode,
      extras : this.props.extras
    };

    // show loading spinner
    this.setState({loading : true});

    RezCentral.getRates(rateData)
    .then(data => {
      var rentalList = [];
      if(typeof data.data.rateProduct !== "undefined")
        rentalList = data.data.rateProduct;
      else
        SCR.resizeParent();

      this.list_copy = rentalList.slice();

      self.setState({
        loading : false,
        rentalList : rentalList,
        errorMessage : data.message
      }, () => {
        //SCR.resizeParent();
      });
    });
  }


  handleFilterSelect(e){
    //console.log('FILTER input checked')
    var code = e.target.value;
    var filters = this.state.filtersSelected;

    // filter the rentalList array
    var filterList = function(list, filters){
        return list.filter((rental) => {
          var passengers = parseInt(rental.passengers);
          //console.log(passengers)

          var returnVal = true;
          filters.forEach(f => {
              //console.log('filter is ='+parseInt(f.replace('+')));
              if(passengers < parseInt(f.replace('+')))
                returnVal = false;
          });

          //console.log('passengers = '+passengers)
          //console.log('return val = '+returnVal)
          return returnVal;
        });
    };

    //console.log(e.target.checked)
    // add filter
    if(e.target.checked){
      filters.push(code);

      var list = filterList(this.state.rentalList, filters);
      this.setState({
        rentalList : list,
        filtersSelected : filters
      });

    }else{ // remove filter
      //console.log("FIlter removed")
      //console.log(this.list_copy)

      const index = filters.indexOf(code);
      if (index > -1) {
        filters.splice(index, 1);
      }

      this.setState({
        rentalList : this.list_copy,
        filtersSelected : filters
      }, () => {
        //console.log('filtered = ' + this.state.filtersSelected);
        //console.log('list = ' + this.state.rentalList);

        var list = filterList(this.state.rentalList, filters);
        list = this.sort(list);
        this.setState({rentalList : list});
      });
    }
  }

  sort(list){
    var sort = this.state.sortSelected;

    var sortLowtoHigh = function(l){
      return l.sort((k, j) => {
        //console.log(k)
        //console.log(j)
        var a = parseInt(k.totalPricing.totalCharges);
        var b = parseInt(j.totalPricing.totalCharges);
        //console.log('a = ' + a)
        //console.log('b = ' + b)

        if(a < b)
          return -1;

        if(a > b)
          return 1;

        return 0;
      });
    };
    var sortHightoLow = function(l){
      return l.sort((k, j) => {
        //console.log(k)
        //console.log(j)
        var a = parseInt(k.totalPricing.totalCharges);
        var b = parseInt(j.totalPricing.totalCharges);
        //console.log('a = ' + a)
        //console.log('b = ' + b)

        if(a < b)
          return 1;

        if(a > b)
          return -1;

        return 0;
      });
    };

    var orderedList = list;
    if(sort === 'lowtohigh')
      orderedList = sortLowtoHigh(list);
    else if (sort === 'hightolow')
      orderedList = sortHightoLow(list);

    return orderedList;
  }

  handleSort(e){
    var code = e.target.value;
    //console.log(code);
    var list = this.state.rentalList;

    this.setState({
      sortSelected : code
    }, () => {
      /*console.log('list-copy')
       console.log(this.list_copy)
       console.log('rentalList')
       console.log(this.state.rentalList)*/

      var orderedList = this.sort(list);
      this.setState({rentalList : orderedList});
    });
  }

  getDateString(d){
    if(d === '')
      return '';

    return ('0' + (d.getMonth()+1)).slice(-2) + ('0' + d.getDate()).slice(-2) + d.getFullYear();
  }

  render(){
    //console.log('Step 2 render called')
    var Rentals = [];

    if(this.state.loading)
      Rentals = <Row><Col className="text-center m-3 p-3"><Spinner animation="border" role="status"></Spinner></Col></Row>;
    else{
      if(this.state.rentalList.length > 0)
        Rentals = <RentalList rentalList={this.state.rentalList} vehicleClass={this.props.vehicleClass} setVehicleClass={this.props.setVehicleClass} personalInfo={this.props.personalInfo} isModifyRez={this.props.isModifyRez} />;
      else if(this.state.errorMessage !== "")
        Rentals = <Row><Col className="text-center border m-3 p-3">{this.state.errorMessage} Please revise your search</Col></Row>;
    }
    //else {
    //  Rentals = <Row><Col className="text-center border m-3 p-3">No Results found for the dates you selected. Please revise your search.</Col></Row>;
    //}

    return (
      <div>
        <Progress pickup={this.props.pickup} dropoff={this.props.dropoff} vehicleClass={this.props.vehicleClass} personalInfo={this.props.personalInfo} extras={this.props.extras} currentStep={this.props.currentStep} isModifyRez={this.props.isModifyRez} returnToStep={this.props.returnToStep} price={this.props.vehicleClass.totalCharges} />

        <Container fluid>
          <Row xs={1} md={2} className="g-2 mb-md-3">
            <Col><h3><b>Select Vehicle Class</b></h3></Col>
            <Col className="d-md-flex justify-content-md-end align-bottom" style={{"position" : "relative"}}>
                <select id="sort-list" onChange={this.handleSort}>
                  <option value="">Sort by</option>
                  <option value="lowtohigh">Price low to high</option>
                  <option value="hightolow">Price high to low</option>
                </select>
            </Col>
          </Row>
          <Row xs={1} md={2}>
            <Col xs={5} sm={3} md={3} className="m-0" style={{"position" : "relative"}}>
                    <Accordion style={{"position" : "absolute"}}>
                      <Accordion.Item eventKey="0" >
                      <Accordion.Header >Filter</Accordion.Header>
                      <Accordion.Body>
                        <p>Passengers </p>
                        <Stack gap={2}>
                          <div><input type="checkbox" value="2+" onChange={this.handleFilterSelect} />2+</div>
                          <div><input type="checkbox" value="4+" onChange={this.handleFilterSelect} />4+</div>
                          <div><input type="checkbox" value="5+" onChange={this.handleFilterSelect} />5+</div>
                          <div><input type="checkbox" value="7+" onChange={this.handleFilterSelect} />7+</div>
                        </Stack>
                      </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
            </Col>
            <Col md={9} id="rental-list">{Rentals}</Col>
          </Row>
      </Container>
    </div>
    );
  }
}
